import { AbstractControl, ValidationErrors } from '@angular/forms';

export function numberAsStringValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!isNaN(value)) {
        return null;
    }

    const noCommas = value.replace(/,/g, '');
    if (!isNaN(noCommas)) {
        return null;
    }

    return { NaN: true };
}
